import { isLocalEnv } from '../../../app/duck';
import { Flex, Image } from '@chakra-ui/react';
import React from 'react';
import { AdoptionRegistration } from './adoption';
import { PreviewRegistration } from './preview';
import styles from './Main.module.css';

interface MainProps {
  isAdoption?: boolean;
}

const Main: React.FC<MainProps> = ({ isAdoption }) => {
  const source = isAdoption
    ? `${isLocalEnv() ? '' : 'login/'}assets/images/mn-background.webp`
    : `${isLocalEnv() ? '' : 'login/'}assets/images/main-background.webp`;

  return (
    <Flex
      as="main"
      alignItems="center"
      justifyContent="center"
      position="relative"
      className={styles.wrapper}
    >
      <Image
        position="absolute"
        top="0"
        bottom="0"
        right="0"
        left="0"
        h="100%"
        w="100%"
        src={source}
        alt=""
        role="presentation"
      />
      {isAdoption ? <AdoptionRegistration /> : <PreviewRegistration />}
    </Flex>
  );
};

export default Main;
